<template>
  <div>
    <div class="relative">
      <Container class="mb-11 !max-w-[650px] text-center lg:mb-16">
        <SubTitle v-if="data?.subtitle" class="text-blue">{{ data?.subtitle }}</SubTitle>
        <Title v-if="data?.title" custom-style="mb-6 leading-none lg:mb-9 lg:leading-none">
          {{ data?.title }}
        </Title>
        <div class="text-center font-sans text-base lg:text-lg" v-html="data?.copy"></div>
      </Container>
    </div>
    <ListBlock :data="data" />
  </div>
</template>

<script setup lang="ts">
import Container from '../atoms/Container.vue'
import SubTitle from '../atoms/SubTitle.vue'
import Title from '../atoms/Title.vue'
import ListBlock from './ListBlock.vue'
import type { ILinkData, ICardData } from '../../types'

export interface IListAutoBlock {
  id: string
  title?: string
  subtitle?: string
  copy?: string
  cards?: ICardData[]
  link?: ILinkData
}

interface Props {
  data: IListAutoBlock
}

defineProps<Props>()
</script>
